import React from "react";
import { SignIn } from "@clerk/clerk-react";
import { Box } from "@mui/material";

export default function Login() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f7fa",
      }}
    >
      <Box
        component="img"
        src="/assets/logo.png"
        alt="Pharma Pipeline"
        sx={{ width: 280, mb: 4 }}
      />
      <SignIn
        routing="hash"
        appearance={{
          elements: {
            card: { boxShadow: "0 2px 12px rgba(0,0,0,0.08)", borderRadius: "12px" },
          },
        }}
      />
    </Box>
  );
}
